import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AutosaveService } from '../autosave.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SimpleGlobalModalService } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'brightside-web-autosave-settings',
    templateUrl: './autosave-settings.component.html',
    styleUrls: ['./autosave-settings.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                maxHeight: '600px',
                opacity: 1,
            })),
            state('closed', style({
                maxHeight: '0',
                opacity: 0,
            })),
            transition('open => closed', [animate('1000ms ease-in-out')]),
            transition('closed => open', [animate('1000ms ease-in-out')]),
        ]),
    ],
    providers: [AutosaveService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AutosaveSettingsComponent {
  currentAutosaveInfo$ = this.autoSaveSvc.currentAutosaveInfo;
  autoSaveAmountSelected$ = this.autoSaveSvc.autoSaveAmountSelected;
  autoSaveOnOff$ = this.autoSaveSvc.autoSaveOnOff;
  isOkToPost$ = this.autoSaveSvc.isOkToPost;
  options$ = this.autoSaveSvc.currentSelectionOption;
  processing$ = this.autoSaveSvc.processing;
  initialAmount = true;

  private _globalModalSvc: SimpleGlobalModalService = inject(SimpleGlobalModalService);

  constructor(
    private autoSaveSvc: AutosaveService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location
  ) {
    if (this.route.snapshot.data['routeOnSuccess']) {
      this.autoSaveSvc.routeOnSuccess = this.route.snapshot.data['routeOnSuccess'];
    }
    if (this.route.snapshot.data['routeOnBack']) {
      this.autoSaveSvc.routeOnBack = this.route.snapshot.data['routeOnBack'];
    }
  }

  ngOnInit() {
    this.initialAmount = true;
    this.autoSaveSvc.getAutoSavingsInfo(true);
  }

  onSubmit() {
    this.autoSaveSvc.createAutoSaveSchedule();
  }

  autosaveAmount($event: number) {
    
    if ($event > 999 && !this.initialAmount) {
      this.autoSaveSvc.setAutoSaveAmount(0);
      this._globalModalSvc.createModal({
        displayCloseButton: false,
        eventName: 'autosave_confirm_amount',
        isError: false,
        size: 'medium',
        title: 'AUTOSAVE_CONFIRM_AMOUNT_TITLE',
        contentKey: 'AUTOSAVE_CONFIRM_AMOUNT_DESC',
        contentKeyParam: { amount : `$${$event}`},
        ctaKey: 'AUTOSAVE_CONFIRM_AMOUNT_CTA1',
        ctaAction: () => {
          this.autoSaveSvc.setAutoSaveAmount($event);
          this._globalModalSvc.clearModal();
        },
        secondaryCtaKey: 'AUTOSAVE_CONFIRM_AMOUNT_CTA2',
        secondaryCtaAction: () => {
          this.autoSaveSvc.setAutoSaveAmount(0);
          this._globalModalSvc.clearModal();
        }
      })
    } else {
      this.autoSaveSvc.setAutoSaveAmount($event);
      this.initialAmount = false;
    }
  }

  toggleAutoSaveFeature($event: boolean) {
    this.autoSaveSvc.setAutoSaveFeature($event);
  }
  routeUserOnBack() {
    if (this.autoSaveSvc.routeOnBack) {
      this.router.navigate(this.autoSaveSvc.routeOnBack);
    } else {
      this._location.back();
    }
  }

}
